import api from ".";
import cookiesModifier from "../utils/cookies";

import { ISaveNotificationFunction } from "../types/custom_notifications";


export const saveNotificationFunction = async (data: ISaveNotificationFunction) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.post(`/notification-functions`, data);
        return res.status;
    } catch (error) {
        throw error;
    }
};

export const deleteNotificationFunction = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`/notification-functions/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
};